import { addMetadata, useApp, useCollection } from '@hb/react'
import { insurersCollection, LogEntry } from '@hb/shared'
import { updateDoc } from 'firebase/firestore'
import React, { useCallback, useMemo } from 'react'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { Loading } from '../../../Loading'
import { LogView } from './LogView'
import { injectAssessmentLogItems } from './utils'
export const AssessmentLog: React.FC<{
  maxHeight: number
}> = ({ maxHeight }) => {
  const data = useProfile()
  const {
    user,
    selectedAssessment: { populated: selectedAssessment, adminRef },
    userId,
  } = data
  const { appName } = useApp()

  const { items: insurers } = useCollection(insurersCollection)
  const injectedLog = useMemo(
    () =>
      injectAssessmentLogItems(selectedAssessment?.log, user, selectedAssessment ?? null, insurers),
    [user, selectedAssessment, insurers],
  )

  const handleUpdateLog = useCallback(
    async (id: string, newEntry: LogEntry) =>
      adminRef
        ? updateDoc(adminRef, `log.${id}`, addMetadata(newEntry, appName, false))
            .then(() => ({ success: 'Updated!' }))
            .catch((err: any) => {
              console.error(err)
              return { error: err.message }
            })
        : { error: 'No adminRef' },
    [adminRef, appName],
  )

  if (!selectedAssessment || !userId) {
    return <Loading text="Loading pregnancy..." />
  }

  return (
    <LogView
      maxHeight={maxHeight}
      type="assessment"
      log={injectedLog}
      updateLog={handleUpdateLog}
    />
  )
}
